<div class="add-checklist-container app_modal-report">
  <p style="font-weight: 600">{{ data.title }}</p>

  <div class="add-input">
    <div class="checklist-name">
      {{
        data?.custom_name
          ? data?.custom_name
          : data?.isWorkspace
          ? 'Workspace Name'
          : data?.isSharedVault
          ? 'Shared Vault Name'
          : data.isReport
          ? ' Report Name'
          : 'Checklist Name'
      }}
    </div>
    <input
      style="width: 100% !important"
      id="checklistNameInput"
      type="text"
      maxlength="50"
      (focus)="selectAllContent($event)"
      (input)="handleInput($event)"
      (keyup.enter)="confirmDialog()"
      [(ngModel)]="checklistName"
    />
  </div>

  <div class="action">
    <span mat-button (click)="closeDialog()">Cancel</span>
    <button mat-button [class.disable-button-continue]="checkIfDisabled()" (click)="confirmDialog()">{{ data.buttonName }}</button>
  </div>
</div>
